import { type FC } from "react";
import type {
  ContractType,
  ContractCompany,
} from "../../services/contract-types";
import { HiCheck, HiPlus } from "react-icons/hi";

interface CompactContractTypeCardProps {
  contractType: ContractType & { company_details: ContractCompany };
  onAdd: () => void;
  isSelected: boolean;
  onRemove: () => void;
}

const CompactContractTypeCard: FC<CompactContractTypeCardProps> = ({
  contractType,
  onAdd,
  isSelected,
  onRemove,
}) => {
  const { type, company_details } = contractType;
  const { color_code, color_code2 } = company_details;

  const handleClick = () => {
    if (isSelected) {
      onRemove();
    } else {
      onAdd();
    }
  };

  return (
    <div
      className={`relative flex min-h-[90px] flex-col rounded-lg p-4 shadow-sm ${
        isSelected ? "ring-2 ring-white" : ""
      }`}
      style={{
        background: `linear-gradient(135deg, ${color_code} 0%, ${
          color_code2 || color_code
        } 100%)`,
      }}
    >
      <div className="mb-2 flex-1">
        <h4 className="line-clamp-2 text-base font-semibold leading-tight text-white">
          {type}
        </h4>
        <p className="mt-1 text-sm font-medium text-white/90">
          {company_details.company}
        </p>
      </div>
      <div className="flex justify-end">
        <button
          onClick={handleClick}
          className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full ${
            isSelected
              ? "bg-red-100 text-red-800 hover:bg-red-200"
              : "bg-white text-gray-800 hover:bg-gray-100 hover:text-gray-900"
          }`}
          aria-label={isSelected ? "Entfernen" : "Hinzufügen"}
        >
          {isSelected ? (
            <HiCheck className="h-4 w-4" />
          ) : (
            <HiPlus className="h-4 w-4" />
          )}
        </button>
      </div>
    </div>
  );
};

export default CompactContractTypeCard;
